import { Component, ViewChild, Injector, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { GetDivisionForViewDto, DivisionDto } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';

@Component({
    selector: 'viewDivisionModal',
    templateUrl: './view-division-modal.component.html'
})
export class ViewDivisionModalComponent extends AppComponentBase {

    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;

    item: GetDivisionForViewDto;


    constructor(
        injector: Injector
    ) {
        super(injector);
        this.item = new GetDivisionForViewDto();
        this.item.division = new DivisionDto();
    }

    show(item: GetDivisionForViewDto): void {
        this.item = item;
        this.active = true;
        this.modal.show();
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }
}
